import './register-warn-container.css';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
const RegisterWarnContainer = ({ registerToSave }) => {
  const { instance } = useMsal();
  const redirectToLogin = () => {
    registerToSave();
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  }
  return (
    <>
      <div className="register-warn-container">
        <div className="warn-message-container">
          <img className="worn-icon" src="./images/warn-icon.png" alt="warn-icon" />
          <span>Register an account to avoid losing the entered information!</span>
        </div>
        <div className="register-button-container">
          <button className="register-save-button" onClick={() => redirectToLogin()}>Register to Save</button>
        </div>
      </div>
    </>
  );
};

export default RegisterWarnContainer;
